/**
 * Resolves API requests for both local Vite development and deployed Pages.
 *
 * Local development deliberately keeps `/api` relative so Vite's proxy can
 * forward it to the local Worker. Deployed builds set VITE_API_URL to the
 * dedicated API Worker origin (for example, https://api.floorfile.com).
 */
const configuredApiUrl = import.meta.env.VITE_API_URL?.trim().replace(/\/$/, '') ?? ''

export function apiBaseUrl(): string {
  if (configuredApiUrl) return `${configuredApiUrl}/`
  return `${globalThis.location?.origin ?? 'http://localhost'}/`
}

export function apiUrl(path: string): string {
  if (!configuredApiUrl || !path.startsWith('/')) return path
  return `${configuredApiUrl}${path}`
}

/** API fetch with cross-origin credentials enabled for the refresh-token cookie. */
export function apiFetch(path: string, init: RequestInit = {}): Promise<Response> {
  return fetch(apiUrl(path), {
    ...init,
    credentials: init.credentials ?? 'include',
  })
}
